export enum MediaTypeEnum {
  video = 'video',
  image = 'image',
  audio = 'audio',
  webPage = 'webPage',
  text = 'text',
  rss = 'rss',
  widget = 'html',
  stream = 'stream',
  application = 'application'
}
